import { oc } from "@orpc/contract";
import { z } from "zod";

export const ItemGroupSchema = z.object({
  id: z.string().uuid(),
  /** For Rexel, a GAINS department code such as WJMA. */
  code: z.string(),
  name: z.string().nullable(),
  memberCount: z.number().int(),
});

export const ListItemGroupsInputSchema = z.object({
  search: z.string().max(100).optional(),
  ids: z.array(z.string().uuid()).max(500).optional(),
  limit: z.coerce.number().int().min(1).max(500).optional().default(50),
});

export const itemGroupsContracts = {
  list: oc
    .input(ListItemGroupsInputSchema)
    .output(z.array(ItemGroupSchema))
    .route({
      method: "GET",
      summary: "List item groups",
      description:
        "Item groups (for Rexel, GAINS departments) by code or name, or by id, with how many products each holds. Supply network lanes filter on them.",
    }),
} as const;

export type ItemGroup = z.infer<typeof ItemGroupSchema>;
